import { useTranslation } from '@wix/yoshi-flow-editor';
import { useChannelPricing, useFormatMessageWithPrice } from '.';
import { useWorker } from './useWorker';
import { useChannelAccessAction } from './useChannelAccessAction';
import { AccessAction } from '../types/enums';

type UseChannelAccessButton =
  | {
      text: string;
      handler(): void;
    }
  | undefined;

export const useChannelAccessButton = (): UseChannelAccessButton => {
  const { t } = useTranslation();
  const { channelSubscription } = useChannelPricing();
  const { formatMessageWithPrice } = useFormatMessageWithPrice();
  const {
    modals: { openDesktopSubscription },
  } = useWorker();
  const accessAction = useChannelAccessAction();

  if (accessAction === AccessAction.PricingPlan) {
    return {
      text: t('widget.mobile.overlay-button.subscribe.short'),
      handler: openDesktopSubscription,
    };
  }

  if (accessAction === AccessAction.Subscribe && channelSubscription) {
    return {
      text: formatMessageWithPrice(
        'widget.channel-actions.subscribe',
        channelSubscription.price,
        channelSubscription.currency,
      ),
      handler: openDesktopSubscription,
    };
  }
};
